<template>
    <form class="row q-col-gutter-md">
        <div class="col-12">
            <q-select
                v-model="UserObj.country"
                :label="$t('users.country_of_id_document')"
                emit-value
                map-options
                option-value="acronym3"
                option-label="name"
                use-input
                :options="options"
                :loading="loading"
                color="primary"
                @filter="filterCountries"
            >
                <template v-slot:option="scope">
                    <q-item
                        v-bind="scope.itemProps"
                        v-on="scope.itemEvents"
                    >
                        <q-item-section avatar>
                            <q-icon :name="scope.opt.acronym" size="sm" />
                        </q-item-section>
                        <q-item-section>
                            <q-item-label>{{scope.opt.name}}</q-item-label>
                        </q-item-section>
                    </q-item>
                </template>

                <template v-slot:before>
                    <q-btn
                        round dense flat size="md" color="primary"
                        icon="far fa-copy"
                        v-clipboard="UserObj.country || ' '"
                        @success="copied($t('field_is_copied', {field: $t('users.country_of_id_document')}))"
                        :disabled="!UserObj.country"
                    />
                </template>
            </q-select>
        </div> <!-- Country -->
        <div class="col-12">
            <q-select
                v-model="UserObj.type"
                :options="types"
                :label="$t('users.id_document_type')"
                emit-value
                map-options
                color="primary"
                option-value="value"
                option-label="label"
            >
                <template v-slot:before>
                    <q-btn
                        round dense flat size="md" color="primary"
                        icon="far fa-copy"
                        v-clipboard="UserObj.type || ' '"
                        @success="copied($t('field_is_copied', {field: $t('users.id_document_type')}))"
                        :disabled="!UserObj.type"
                    />
                </template>
            </q-select>
        </div> <!-- Type -->
        <div class="col-12">
            <q-input
                v-model="UserObj.id_number"
                :label="$t('users.id_number')"
                lazy-rules
                color="primary"
            >
                <template v-slot:before>
                    <q-btn
                        round dense flat size="md" color="primary"
                        icon="far fa-copy"
                        v-clipboard="UserObj.id_number || ' '"
                        @success="copied($t('field_is_copied', {field: $t('users.id_number')}))"
                        :disabled="!UserObj.id_number"
                    />
                </template>
            </q-input>
        </div> <!-- id_number -->
        <div class="col-12">
            <q-input :label="$t('users.expiry_date')" v-model="UserObj.expiry_date" mask="####/##/##">
                <template v-slot:append>
                    <q-icon name="event" class="cursor-pointer">
                        <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                            <q-date v-model="UserObj.expiry_date" mask="YYYY/MM/DD">
                                <div class="row items-center justify-end">
                                    <q-btn v-close-popup label="Set" color="primary" flat />
                                </div>
                            </q-date>
                        </q-popup-proxy>
                    </q-icon>
                </template>
                <template v-slot:before>
                    <q-btn
                        round dense flat size="md" color="primary"
                        icon="far fa-copy"
                        v-clipboard="UserObj.expiry_date || ' '"
                        @success="copied($t('field_is_copied', {field: $t('users.expiry_date')}))"
                        :disabled="!UserObj.expiry_date"
                    />
                </template>
            </q-input>
        </div> <!-- Expiry Date -->
    </form>
</template>
<script>

import {mapActions, mapGetters} from 'vuex'
export default {
    name: "IdDocumentForm",
    model: {
        prop: 'UserObj',
        event: 'change'
    },
    props: {
        UserObj: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters(['id_valid_countries']),
    },
    data() {
        return {
            loading:false,
            types: [
                {label: this.$t('users.id_document_type_labels.driver_licence'), value: 'driver_licence'},
                {label: this.$t('users.id_document_type_labels.passport'), value: 'passport'},
                {label: this.$t('users.id_document_type_labels.identification_card'), value: 'id_card'},
            ],
            options: null,
        }
    },
    methods: {
        ...mapActions(['set_countries']),
        copied(message) {
            this.$q.notify({
                message: message,
                position: 'top'
            })
        },
        filterCountries(val, update, abort) {
            if (val === '') {
                update(() => {
                    this.options = this.id_valid_countries
                })
                return
            }

            update(() => {
                const needle = val.toLowerCase()
                this.options = this.id_valid_countries.filter(country => country.name.toLowerCase().indexOf(needle) > -1)
            })
        },
    },
    created() {
    },
    mounted() {
        if (! this.id_valid_countries.length) {
            this.loading = true
            this.set_countries().then(() => {this.loading = false}).catch(() => {this.loading = false})
        }
    },
    watch: {},
    components: {},
}
</script>
<style>

</style>
